import React from 'react';
import { Link } from 'react-router-dom';

import Subnav from '../subnav';

import AccountManagerForm from './AccountManagerForm';
import AuthService from '../../state/auth.service';

const AccountManagerPage = () => {
    const user = AuthService.getUser();

    let pageTitle = 'Your Account';
    if (user.name && user.name.length > 0) {
        pageTitle = `Hello ${user.name}!`;
    }

    return (
        <div className="page">
            <div className="page__subnav">
                <Subnav />
            </div>
            <div className="page__body splitpage">
                <h2>{pageTitle}</h2>
                <p className="lead">
                    You can update your account information using the fields
                    below.
                </p>

                <div className="row">
                    <div className="column">
                        <AccountManagerForm />
                    </div>
                    <div className="column">
                        <div className="form__field">
                            <label htmlFor="email">Email</label>
                            {user.email}
                        </div>

                        <div className="form__field">
                            <label htmlFor="password">Password</label>
                            <Link to="/user/account/password">
                                Click here to update your password.
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountManagerPage;
